import React from "react";
import { InputGroup } from "@sonder/ui/source/styled/fragments/InputGroup";
import { AdditionalFilters } from "tasks/components/Filters/AdditionalFilters";
import { AssigneeFilters } from "tasks/components/Filters/AssigneeFilters";
import { BuildingFilters } from "tasks/components/Filters/BuildingFilters";
import { ClearFilterButton } from "tasks/components/Filters/ClearFilterButton";
import { CreateSavedFilter } from "tasks/components/Filters/CreateSavedFilter";
import { FilterButton } from "tasks/components/Filters/FilterButton";
import { SavedFilterPicker } from "tasks/components/Filters/SavedFilterPicker";
import { TaskTypeFilters } from "tasks/components/Filters/TaskTypeFilters";
import { isDuringStayFilterActive } from "tasks/helpers";
import { FilterDuringStay } from "typings/globalGQLTypes";

export const Filters = () => {
  return (
    <InputGroup>
      <AssigneeFilters />
      <BuildingFilters />
      <TaskTypeFilters />
      <FilterButton
        filters={{ duringStay: FilterDuringStay.during_stay }}
        isActive={isDuringStayFilterActive}
        label="During Stay"
        segmentId="filter_shortcut.during_stay"
      />
      <AdditionalFilters />
      <SavedFilterPicker eventName="view_header" />
      <CreateSavedFilter eventName="view_header" />
      <ClearFilterButton />
    </InputGroup>
  );
};
